export const baseEvent = {
  context: 'PAYOUT',
} as const
